export type SessionStore = {
	clean: () => void
	get: (key: string) => string | null
	set: (key: string, value: string) => void
	remove: (key: string) => void
}

export const useSessionStore = (): SessionStore => {
	const clean = () => {
		window.sessionStorage.clear()
	}

	const get = (key: string) => {
		return window.sessionStorage.getItem(key)
	}

	const set = (key: string, value: string) => {
		window.sessionStorage.setItem(key, value)
	}
	const remove = (key: string) => {
		window.sessionStorage.removeItem(key)
	}
	return {
		clean,
		get,
		set,
		remove
	}
}